import { SITE_PAGES_GRID } from '../constants';


export const getPageGridName = pageId => `${SITE_PAGES_GRID}_${pageId}`;
